module.exports = __webpack_public_path__ + "static/img/slaServer1.a4d42ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slaServer1.png
// module id = OFkP
// module chunks = 2